import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { ExerciseModel } from '../../models/models';
import { ConfigurationProvider, ExerciseProvider } from '../../providers/providers';

@Component({
  selector: 'page-exercise-edit',
  templateUrl: 'exercise-edit.html',
})
export class ExerciseEditPage {
  item: ExerciseModel;

  constructor(
    private config: ConfigurationProvider,
    private exerciseProvider: ExerciseProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.Name : null
    });
  }

  ionViewWillLoad() {
    this.item = this.params.get('item');
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');
      // save item
      this.exerciseProvider.Save(this.item).then((res: ExerciseModel) => {
        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res); 
      });
    }
  }

  formIsValid() {
    if (!this.item.Name) {
      this.config.showAlert('Error', 'Must enter a Name.');
      return false;
    }

    // check if item exists
    if (this.exerciseProvider.Exists(this.item)) {
      this.config.showAlert('Error', 'Exercise with this name already exists!');
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/exercises/exercise-edit.ts